(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('MaquinaEditCtrl', MaquinaEditController);

  MaquinaEditController.$inject = [
    '$scope',
    'MessagesService',
    'MaquinasService',
    'LoadingService',
    'AgrothingsIntegrationService',
    'ItemSelectionService'
  ];

  // eslint-disable-next-line max-lines-per-function, max-params
  function MaquinaEditController($scope, MessagesService, MaquinasService, LoadingService, AgrothingsIntegrationService,
    ItemSelectionService) {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.maquina = null; // vem da diretiva
    vm.groups = null; // vem da diretiva
    vm.editMaquina = {
      descricao: '',
      alimentacao: null,
      capacidade_tanque: null,
      grupo: null,
      propriedades: null,
      tipo_controle_manutencao: null,
      st_conjunto: null,
      dt_baixa: null,
      largura_trabalho: null,
      id: null,
      integracao_gps_id: null
    };
    vm.loading = false;

    //////////////////////////////////////////
    // Bindable methods
    vm.cancel = cancel;
    vm.saveMaquina = saveMaquina;
    vm.deleteMaquina = deleteMaquina;
    vm.toggleActive = toggleActive;
    vm.openIntegrationMachineModal = openIntegrationMachineModal;
    vm.isShowing = isShowing;

    //////////////////////////////////////////
    // Function declarations
    function isShowing() {
      const permissions = angular.copy($scope.$root.permissions.maquina);
      if ($scope.$root.parametros.enable_sync_to_postgres && !$scope.$root.parametros.nao_cliente_agrogestao) {
        permissions.canManage = false;
      }

      return permissions.canRead && !permissions.canManage;
    }

    function getBasicData() {
      vm.editMaquina.descricao = vm.maquina.descricao;
      vm.editMaquina.alimentacao = vm.maquina.alimentacao;
      vm.editMaquina.capacidade_tanque = +vm.maquina.capacidade_tanque;
      vm.editMaquina.grupo = _.find(vm.groups, { id: vm.maquina.grupo.id });
      vm.editMaquina.tipo_controle_manutencao = vm.maquina.tipo_controle_manutencao === 'horimetro' ? 'H' : 'K';
      vm.editMaquina.st_conjunto = vm.maquina.st_conjunto;
      vm.editMaquina.integracao_gps_id = vm.maquina.integracao_gps_id;
      vm.editMaquina.dt_baixa = vm.maquina.dt_baixa && new Date(vm.maquina.dt_baixa);
      vm.editMaquina.id = vm.maquina.id;
      vm.editMaquina.largura_trabalho = +vm.maquina.largura_trabalho;

      vm.loading = true;
      MaquinasService.get(vm.maquina.id)
        .then((maquina) => {
          vm.editMaquina.propriedades = $scope
            .$root
            .propriedades
            .filter((propriedade) => _.find(maquina.data.propriedades, { id: propriedade.id }));
        })
        .catch((error) => {
          console.error('Não foi possível carregar os detalhes da máquina', error);
          MessagesService.alert('Não foi possível carregar todos os detalhes da máquina.');
        })
        .finally(() => vm.loading = false);
    }

    function cancel() {
      reset();
      if (!vm.maquina) {
        return $scope.$emit('cancelCreate');
      }
      $scope.$emit('cancelEdit', vm.maquina);
    }

    function reset() {
      if (!vm.maquina) {
        // Criando uma nova maquina, então reseta os valores para quando for criar novamente
        for (const key in vm.editMaquina) {
          vm.editMaquina[key] = null;
        }
      } else {
        // Estava editando um item, volta os valores originais não alterados
        getBasicData();
      }
    }

    // eslint-disable-next-line max-lines-per-function
    function saveMaquina(event) {
      if (event) {
        preventDefault(event);
      }

      vm.loading = true;
      return MaquinasService.save(vm.editMaquina)
        .then(() => {
          if (vm.maquina) {
            return MaquinasService.get(vm.maquina.id);
          }
          return null;
        })
        .then((result) => {
          if (result) {
            MessagesService.alert('Máquina atualizada com sucesso!');
            return $scope.$emit('maquinaUpdated', vm.maquina, result.data);
          }
          MessagesService.alert('Máquina criada com sucesso!');
          $scope.$emit('maquinaCreated');
          reset();
        })
        .catch((error) => {
          console.error('Erro ao salvar máquina', error);
          let message = '';
          if ((error.data.integracao_gps_id || []).includes('já está em uso')) {
            message += 'Já existe uma máquina com esse código de integração com GPS';
          }
          MessagesService.alert(message || 'Erro ao salvar máquina, tente novamente.');
        })
        .finally(() => vm.loading = false);
    }

    function deleteMaquina() {
      return MessagesService.confirm(`Você tem certeza que deseja apagar a máquina ${vm.maquina.descricao}?`)
        .then(() => {
          vm.loading = true;
          return MaquinasService.deleteMaquina(vm.maquina.id);
        })
        .then(() => {
          MessagesService.alert('Máquina apagada com sucesso!');
          $scope.$emit('maquinaCreated');
        });
    }

    function toggleActive() {
      if (vm.inactive) {
        vm.editMaquina.dt_baixa = new Date();
      } else {
        vm.editMaquina.dt_baixa = null;
      }
    }

    function openIntegrationMachineModal() {
      LoadingService.showLoading();
      AgrothingsIntegrationService
        .listMachinary()
        .then(function(data) {
          const options = { primaryKey: 'device_id', descriptionKey: 'device_name' };
          return ItemSelectionService.open(data.data || [], 'Máquina', options);
        })
        .then((machine) => {
          vm.editMaquina.integracao_gps_id = machine.device_id;
        })
        .catch(function(error) {
          if (error) {
            console.error('Erro ao buscar máquinas', error);
            MessagesService.alert('Erro ao buscar máquinas');
          }
        })
        .finally(LoadingService.hideLoading);
    }


    //////////////////////////////////////////
    // Controller logic
    const maquinaWatcher = $scope.$watch('edit.maquina', () => {
      maquinaWatcher();

      if (vm.maquina) {
        getBasicData();
      }
    });
  }
}());
